const uae = [
  { "code": "Abu Dhabi", "name": "Abu Dhabi" },
  { "code": "Ajman", "name": "Ajman" },
  { "code": "Dubai", "name": "Dubai" },
  { "code": "Fujairah", "name": "Fujairah" },
  { "code": "Ras al-Khaimah", "name": "Ras al-Khaimah" },
  { "code": "Sharjah", "name": "Sharjah" },
  { "code": "Umm al-Quwain", "name": "Umm al-Quwain" }
];
export default uae;